<div
  *ngFor="let type of listReverseConfigType"
  class="vw-100 d-flex direction-column pb-40"
>
  <span class="pb-10 text-size-20 text-bold-700"
    >Estorno
    {{
      type === ReverseConfiguration.DEFAULT ? "Padrão" : "por Grupo Econômico"
    }}</span
  >
  <app-header-list
    [headerItems]="reverseConfigHeaderItems[type]"
    [textCenter]="true"
  >
    <div button class="d-flex justify-flex-end flex-1">
      <button
        type="button"
        class="btn-register h-28 w-130"
        (click)="openReverseConfigDialog(type)"
      >
        <span class="d-flex justify-center align-center">
          <app-svg-icon
            src="../../../../assets/icons/vector-comissao.svg"
            color="white"
            width="12px"
            height="12px"
            class="mr-10"
          >
          </app-svg-icon>
          <span>Cadastrar</span>
        </span>
      </button>
    </div>
  </app-header-list>

  <ng-container
    *ngFor="let item of reverseConfigurations[type].reverseConfigurations"
  >
    <app-card-configuracoes
      [cardType]="DialogEmailTypeEnum.ReverseConfig"
      [typeReverseConfig]="type"
      [reverseConfig]="item"
      (updateEvent)="openReverseConfigDialog(type, item)"
      (deleteEvent)="handleOpenDialogDelete(type, item)"
    ></app-card-configuracoes>
  </ng-container>

  <ng-container
    *ngIf="reverseConfigurations[type].reverseConfigurations.length === 0"
  >
    <app-empty-card
      class="mt-10"
      text="Não há configurações cadastradas"
    ></app-empty-card>
  </ng-container>

  <ng-container
    *ngIf="reverseConfigurations[type].reverseConfigurations.length > 0"
  >
    <app-pagination-footer
      (paginationTrigger)="handlePagination($event, type)"
      [count]="reverseConfigurations[type].count"
    ></app-pagination-footer>
  </ng-container>
</div>
